import Reveal from "../common/reveal";
import { META_STRIP } from "../../data/home";

const MetaStrip = () => (
	<Reveal as="section" className="wrap">
		<div className="meta-strip">
			{META_STRIP.map((cell) => (
				<div className="meta-cell" key={cell.label}>
					<div className="meta-label">{cell.label}</div>
					<div className="meta-value">{cell.value}</div>
					<div className="meta-sub">{cell.sub}</div>
				</div>
			))}
		</div>
	</Reveal>
);

export default MetaStrip;
